import { config } from 'api';
import { Url } from 'lib/utils/url';
import errorHandler from 'lib/utils/errorHandler';

import { changeBasketQuantity } from 'apps/basket/actions/basket';
import { showTrolleyInfoBox } from 'apps/subscriptions/actions/subscriptions';

import Locations from 'apps/basket/models/Locations';

export const OPEN_MOBILE_TROLLEY = 'OPEN_MOBILE_TROLLEY';
export const CLOSE_MOBILE_TROLLEY = 'CLOSE_MOBILE_TROLLEY';
export const OPEN_REMOVE_ALL_CONFIRM = 'OPEN_REMOVE_ALL_CONFIRM';
export const CLOSE_REMOVE_ALL_CONFIRM = 'CLOSE_REMOVE_ALL_CONFIRM';

export function openTrolleyMenu() {
  return (dispatch, getState) => {
    dispatch({ type: OPEN_MOBILE_TROLLEY });

    if (getState().user.features.indexOf('SUBSCRIPTIONS')) {
      dispatch(showTrolleyInfoBox());
    }
  };
}

export function closeTrolleyMenu() {
  return { type: CLOSE_MOBILE_TROLLEY };
}

export function openRemoveAllConfirm() {
  return { type: OPEN_REMOVE_ALL_CONFIRM };
}

export function closeRemoveAllConfirm() {
  return { type: CLOSE_REMOVE_ALL_CONFIRM };
}

export function addAllInstantShopItems() {
  const apiUrl = new Url(`${config.apiBasePath}/suggested-order`).toString();
  return (dispatch, getState, { network }) =>
    network.get(apiUrl)
      .then(resp => {
        const itemsObject = {};
        resp.items.forEach(item => {
          itemsObject[item.sku] = item.quantity;
          return item;
        });
        return dispatch(changeBasketQuantity({
          items: itemsObject,
          location: Locations.SO_SB_BULK_ADD,
          enrichedItems: resp.items,
        }));
      })
      .catch(errorHandler);
}
